// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/xdl/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vimeo-pricing{\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n    scale: 1.2;\n    transform: translateX(40px);\n}\n\n.vimeo-pricing-mob{\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n}", ""]);
// Exports
module.exports = exports;
